<div class="pme-container">
    <div class="pme-new-row" *ngIf="confirmationData">
        <div class="invoice">
            <pme-mobile-dropdown>
                <p title class="color-blue">Resumo do pedido</p>
                <div content>
                    <mat-card class="pme-new-cart-card">
                        <mat-card-content>
                            <b class="color-blue">Produto escolhido</b>
                            <div class="product-choice">
                                <div class="product-choice-info">
                                    <p class="font-size-16">{{confirmationData.product.classificationIdentifier ===
                                        "consulta-e-recuperacao-de-dividas" ? "Pacote de créditos" : getPlanType()}}</p>
                                    <p id="description">{{confirmationData.product.classificationName}}</p>
                                </div>
                                <div class="product-choice-price">
                                    <b>{{confirmationData.product.value | currency: 'R$'}}</b>
                                </div>
                            </div>

                            <div class="discount-description">
                                <!-- Descontos convencionais -->
                                <div class="discount-description-price"
                                    *ngIf="appliedCoupons && appliedCoupons.length > 0">
                                    <p id="color-blue-coupon" class="font-size-16"
                                        *ngIf="appliedCoupons.length > 1; else singleDiscount">
                                        Descontos aplicados</p>
                                    <ng-template #singleDiscount>
                                        <p id="color-blue-coupon" class="font-size-16">Desconto aplicado</p>
                                    </ng-template>
                                    <div>
                                        <li class="display-utils-row display-utils-between-center display-utils-gap-8"
                                            *ngFor="let discount of appliedCoupons">
                                            <b id="color-blue-coupon" *ngIf="discount.type !== 'EXTRA_BALANCE'">
                                                {{discount.trybuy ? discount.deal : (discount.discountAmount | currency:
                                                'R$')}}
                                            </b>
                                        </li>
                                    </div>
                                </div>

                                <!-- Desconto de balanço extra -->
                                <div>
                                    <div class="discount-description-price"
                                        *ngIf="extraBalanceCoupon && extraBalanceCoupon.length > 0">
                                        <p id="color-blue-coupon" class="font-size-16">Bônus</p>
                                        <div>
                                            <li class="display-utils-row display-utils-between-center display-utils-gap-8"
                                                *ngFor="let discount of extraBalanceCoupon">
                                                <b id="color-blue-coupon">{{discount.totalCredit -
                                                    confirmationData.product.value | currency:
                                                    'R$'}}</b>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>

                            <!-- Total -->
                            <div class="pme-cart-total color-blue" *ngIf="appliedCoupons && appliedCoupons.length > 0">
                                <div class="pme-cart-total-content">
                                    <div>
                                        <p class="font-size-16">Total</p>
                                    </div>
                                    <div>
                                        <span>
                                            <b id="currency">R$ </b>
                                            <b id="main-value">{{totalValue.toString().split(".")[0]}}</b>
                                            <b id="cents">,{{totalValue.toFixed(2).toString().split(".")[1]}}</b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <hr *ngIf="appliedCoupons && appliedCoupons.length > 0">

                            <!-- Cartão de crédito -->
                            <div *ngIf="confirmationData.paymentMethod === 'CREDIT_CARD'" class="payment-method">
                                <b class="color-blue">Forma de pagamento</b>
                                <div class="payment">
                                    <div class="payment-info">
                                        <p>Cartão de crédito</p>
                                        <img id="cardLogo"
                                            src="/assets/images/payment-methods/{{getBrandCSSMatching()}}.png">
                                    </div>
                                </div>
                            </div>
                            <!-- Boleto -->
                            <div *ngIf="confirmationData.paymentMethod === 'BANK_BILLET'" class="payment-method">
                                <b class="color-blue">Forma de pagamento</b>
                                <div class="payment">
                                    <div class="payment-info">
                                        <p>Boleto bancário</p>
                                        <img id="billet" src="/assets/images/payment-methods/boleto.svg">
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </pme-mobile-dropdown>
        </div>

        <div class="purchase-info">
            <p id="font-size-16">Confirmação de pedido</p>
            <p id="font-size-24">Estamos quase lá!</p>

            <div class="bpo-analysis">
                <p id="purchase-info">Falta pouco para ter acesso ao produto solicitado!</p>
                <b>Recebemos seu pedido e logo confirmaremos sua compra!</b>

                <mat-card>
                    <mat-card-content>
                        <p>Te avisaremos por e-mail assim que o status for atualizado :)</p>
                    </mat-card-content>
                </mat-card>
                <button id="width-100" mat-flat-button (click)="onSuccessButtonClick.emit()">Acessar produtos
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>